import React, { Component } from "react";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip,
  BarChart,
  Bar,
  Cell
} from "recharts";

const CustomBarLabel = ({
  x,
  y,
  width,
  height,
  value,
  xOffset = 30,
}) => {
  const xxOffset = x + width + xOffset;
  const yyOffset = y + height / 2;

  return (
    <text
      x={xxOffset}
      y={yyOffset}
      textAnchor="middle"
      dominantBaseline="middle"
      style={{
        fontSize: 16,
        lineHeight: 24,
        color: '#0F2847'
      }}
    >
      {value}
    </text>
  );
}
const CustomLineLabel = (props) => {
  const { x, y, value } = props;

  return (
    <text
      x={x}
      y={y}
      style={{
        fill: '#0F2847',
        fontWeight: '700'
      }}
    >
      {value}
    </text>
  )
}

const getAllValues = data => {
  return data
    .map(item => [
      Number(item.student),
      Number(item.teamAverage),
      Number(item.teamMedian)
    ])
    .reduce((result, currentArray) => [...result, ...currentArray], []);
};

class Chart extends Component {
  render() {
    const {
      data,
      isBarChart,
      isLineChart,
      chartColors
    } = this.props;

    const allValues = isLineChart ? getAllValues(data) : null;

    return isBarChart ? (
      <ResponsiveContainer width="100%" height={136}>
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 0, left: 0, right: 45, bottom: 0 }}
        >
          <XAxis type="number" hide={true} domain={[0, 5]} />
          <YAxis type="category" hide={true} />
          <Bar
            dataKey="value"
            label={
              <CustomBarLabel />
            }
          >
            {
              data.map((item, index) => (
                <Cell
                  key={index}
                  fill={item.color}
                />
              ))
            }
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    ) : isLineChart ? (
      <ResponsiveContainer width="100%" height={200}>
        <LineChart
          data={data}
          margin={{
            top: 0,
            right: 0,
            left: 0,
            bottom: 0
          }}
        >
          <Tooltip />
          <XAxis
            dataKey="name"
            padding={{ top: 30, left: 30, right: 30, bottom: 30 }}
            hide={true}
          />
          <YAxis
            hide={true}
            domain={[
              Math.min.apply(null, allValues) * 0.9,
              Math.max.apply(null, allValues) * 1.1
            ]}
          />
          <Line
            type="monotone"
            dataKey="student"
            name="Student"
            stroke={chartColors[0]}
            dot={false}
            activeDot={false}
            label={<CustomLineLabel />}
            strokeWidth={2}
          />
          <Line
            type="monotone"
            dataKey="teamAverage"
            name="Team Average"
            stroke={chartColors[1]}
            dot={false}
            activeDot={false}
            label={<CustomLineLabel />}
            strokeWidth={2}
          />
          <Line
            type="monotone"
            dataKey="teamMedian"
            name="Team Median"
            stroke={chartColors[2]}
            dot={false}
            activeDot={false}
            label={<CustomLineLabel />}
            strokeWidth={2}
          />
        </LineChart>
      </ResponsiveContainer>
    ) : null;
  }
}

export default Chart;


// WEBPACK FOOTER //
// ./src/instructor/components/peer-feedback/components/peer-rating-chart.js